import { Suspense } from "react";
import { Box, Center, Loader, Stack } from "@mantine/core";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { getSubject } from "@/shared/providers/casl-provider/authorization/subjects";

import Header from "./-components/Header";

export const Route = createFileRoute(
  "/_app/(single-location)/museum/$museumId",
)({
  beforeLoad: ({ params, context }) => {
    const canAccessMuseum = context.ability.can(
      "read",
      getSubject("SingleLocationView", {
        id: params.museumId,
      }),
    );

    if (!canAccessMuseum) {
      console.error(`User does not have access to Museum ${params.museumId}`);
      redirect({
        to: "/unauthorized",
        throw: true,
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Stack className="h-screen w-screen" gap={0}>
      {/* <MobileNavbar hiddenFrom="md" /> */}
      {/* <DesktopNavbar /> */}
      <Header />

      <Box id="page-container" style={{ overflowX: "hidden", flex: 1 }}>
        <Suspense
          fallback={
            <Center h="100%">
              <Loader />
            </Center>
          }
        >
          <Outlet />
        </Suspense>
      </Box>
    </Stack>
  );
}
